import type { TakeReviewLabel } from '@/components/molecules/take-review-surface';

const FRONTEND_TO_BACKEND: Record<TakeReviewLabel, string> = {
  scratch: 'scratch',
  'in-progress': 'in_progress',
  polished: 'polished',
  reference: 'reference',
};

const BACKEND_TO_FRONTEND: Record<string, TakeReviewLabel> = {
  scratch: 'scratch',
  in_progress: 'in-progress',
  polished: 'polished',
  reference: 'reference',
};

export function toBackendLabel(label: TakeReviewLabel): string {
  return FRONTEND_TO_BACKEND[label];
}

export function toFrontendLabel(canonicalName: string): TakeReviewLabel {
  const mapped = BACKEND_TO_FRONTEND[canonicalName];
  if (!mapped) {
    throw new Error(`Unknown take label canonical name: ${canonicalName}`);
  }
  return mapped;
}
